import type { Device, DeviceType, DevicePaymentMethod } from "../../../../api/devices";
import type { UserListItemOut } from "../../../../api/auth";
import PosPrinterModal from "./pos/PosPrinterModal";
import FiscalPrinterModal from "./fiscal/FiscalPrinterModal";
import TerminalModal from "./terminal/TerminalModal";

// Стойностите на формата. При създаване GUID-ът се генерира тук (v4-образен,
// както досега); paymentMethods имат смисъл само при фискален.
export type DeviceFormValues = {
  guid: string;
  name: string;
  type: DeviceType;
  userIds: number[];
  stationIds: number[];
  printLanguage: string | null;
  summarizeReceipt: boolean;
  nonFiscalCopy: boolean;
  paymentMethods: DevicePaymentMethod[];
};

const generateGuid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

interface Props {
  open: boolean;
  // Създаване (device=null) или редакция (device подаден за префил).
  device?: Device | null;
  // Типът е ФИКСИРАН и в двата режима: при създаване идва от секцията,
  // чийто бутон е отворил модала; при редакция — от самото устройство.
  initialType: DeviceType;
  users: UserListItemOut[];
  devices: Device[];
  // Извикващият прави мутацията и toast-овете; при грешка модалът остава отворен.
  onSubmit: (values: DeviceFormValues) => Promise<void>;
  onCancel: () => void;
}

/**
 * Входът на модала за устройство: всеки тип има свой модал (POS, фискален,
 * терминал за плащане). Типът е фиксиран — при създаване идва от секцията,
 * при редакция — от устройството.
 */
const DeviceFormModal = (props: Props) => {
  const type = props.device?.type ?? props.initialType;
  const TypeModal =
    type === "pos" ? PosPrinterModal : type === "fiscal" ? FiscalPrinterModal : TerminalModal;
  return (
    <TypeModal
      open={props.open}
      device={props.device ?? null}
      users={props.users}
      devices={props.devices}
      newGuid={generateGuid}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export default DeviceFormModal;
